<script lang="ts">
    import PortfolioBalancerReportPage from '@Reports/Reports/Pages/PortfolioBalancerReportPage'
    export default PortfolioBalancerReportPage
</script>

<template>
    <div>
        <NumericInputDialog :viewModel="numericInputDialog" @update-value="handleMultipleAlternativesAttributeValueUpdateCommand" />
        <ListSelectionDialog :viewModel="statusListSelectionDialog" @update-value="handleUpdateMultipleAlternativesStatusCommand" />
        <ListSelectionDialog :viewModel="attrListSelectionDialog" @update-value="handleMultipleAlternativesAttributeValueUpdateCommand" />
        <StaticViewBuilder :viewModel="staticViewBuilder" @create-static-list="handleCreateStaticViewCommand" />
        
        <ReportEditor :viewModel="reportEditor" 
                      @update-report="handleUpdateReportCommand" />

        <AlternativeEditorDialog :viewModel="alternativeEditorDialog" />

        <AlternativesComparisonDialog :viewModel="alternativesComparisonDialog" />

        <KendoChartFullScreenDialog :propOpened="fullScreenChart != null"
                                    :propChart="fullScreenChart?.Chart"
                                    :propTitle="fullScreenChart?.Title"
                                    @close-dialog="fullScreenChart = null" />

        <KendoGridColumnsEditorDialog :propOpened="kendoGridColumnsEditorDialogOpened"
                                      :propGrid="grid"
                                      @close-dialog="kendoGridColumnsEditorDialogOpened = false" />

        <h3 v-if="!rm"><i class="fa fa-spinner fa-spin"></i> Loading...</h3>

        <PortfolioNavigation v-if="rm?.IsWorkspaceUser" :workspaceId="workspaceId" :projectId="projectId" />

        <div v-if="rm" class="container-fluid">

            <div class="row">
                <div class="col-lg-10 offset-lg-1" style="padding-top: 130px;">
                    <div class="row">
                        <div class="col-lg-6">
                            <div v-if="rm.Readonly">
                                <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">{{rm.Report.Name}}</h1>
                                <p class="lead">{{rm.Report.Description}}</p>
                            </div>
                            <div v-if="!rm.Readonly" class="pointer" @click="showReportEditor">
                                <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">
                                    <span class="editable editable-success">{{rm.Report.Name}}</span>
                                </h1>
                                <p class="lead">{{rm.Report.Description}}</p>
                            </div>
                        </div>
                        <div v-if="!rm.Readonly" class="col-lg-6 text-right align-self-end">

                            <div class="btn-group">
                                <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                    Create
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item" @click="createMetric">Metric</a>
                                    <a class="dropdown-item" @click="createScatterChart">Scatter plot</a>
                                    <a class="dropdown-item" @click="createBalancingChart">Column chart</a>
                                    <a class="dropdown-item" @click="createBubbleChart">Bubble chart</a>
                                </div>
                            </div>

                            <a class="btn btn-outline-secondary" v-sanitizedHref="`/#/sharing/resource/ReportsDataShareResourceProvider/${reportId}`">Share</a>
                            <button type="button" class="btn btn-success" @click="handleUpdatePortfolioBalancerReportCommand">Save</button>
                        </div>
                    </div>
                </div>
            </div>

            <hr style="border-color: #bbb; margin: 20px 0 60px;" />

            <div class="row">
                <div class="col-lg-10 offset-lg-1">

                    <div v-if="!rm.Readonly" class="card bg-light">
                        <div class="card-body">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Filter by list:</label>
                                            <select class="form-control" v-model="SelectedList">
                                                <option :value="null">All</option>
                                                <option v-for="list in rm.Lists" :key="list.Id" :value="list">{{ list.Name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Group by text attribute:</label>
                                            <select class="form-control" v-model="GroupByAttribute">
                                                <option :value="null">No grouping</option>
                                                <option v-for="attribute in TextAttributes" :key="attribute.Id" :value="attribute">{{ attribute.Name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Edit form:</label>
                                            <select class="form-control" v-model="Form">
                                                <option :value="null">None</option>
                                                <option v-for="form in rm.Forms" :key="form.Id" :value="form">{{ form.Name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div v-for="m in Metrics" :key="m.MetricId" class="mt-3" :class="m.WidthCss">
                            <div class="card" v-if="!m.IsEdited">
                                <div class="card-header">
                                    <div v-if="!rm.Readonly" class="dropdown float-right">
                                        <a data-toggle="dropdown" class="text-dark">
                                            <i class="fa fa-lg fa-ellipsis-h"></i>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right" role="menu">
                                            <a class="dropdown-item" @click="m.IsEdited = true">Edit</a>
                                            <a class="dropdown-item" @click="m.clone()">Clone</a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="m.moveUp()">Move up</a>
                                            <a class="dropdown-item" @click="m.moveDown()">Move down</a>
                                            <div class="dropdown-divider"></div>
                                            <h6 class="dropdown-header">Width</h6>
                                            <a class="dropdown-item" @click="m.Size = '1/4'">1/4</a>
                                            <a class="dropdown-item" @click="m.Size = '1/3'">1/3</a>
                                            <a class="dropdown-item" @click="m.Size = '1/2'">1/2</a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="m.deleteMetric()">Delete</a>
                                        </div>
                                    </div>
                                    <h5>{{m.Title}}</h5>
                                </div>
                                <div class="card-body">
                                    <h4>
                                        <span :style="{'color': m.Color}">{{m.ValueStr}}</span>
                                    </h4>
                                    <p>
                                        <span v-if="m.LimitMin != null">{{m.LimitMinStr}}</span>&nbsp;
                                        <br />
                                        <span v-if="m.LimitMax != null">{{m.LimitMaxStr}}</span>&nbsp;
                                    </p>
                                </div>
                            </div>

                            <div class="card" v-if="m.IsEdited">
                                <div class="card-header">
                                    <div class="float-right">
                                        <a class="pointer" @click="m.closeEditor()">
                                            <span class="fa fa-check fa-lg" style="z-index: 100;"></span>
                                        </a>
                                    </div>
                                    <h5>Edit metric</h5>
                                </div>

                                <div class="card-body">
                                    <h6>Title:</h6>
                                    <p>
                                        <input type="text" v-model.trim="m.Title" class="form-control" />
                                    </p>

                                    <div class="row mt-3">
                                        <div class="col-md-6">
                                            <h6>Attribute:</h6>
                                            <select class="form-control" v-model="m.Attribute">
                                                <option :value="null">Number of projects</option>
                                                <option v-for="attr in NumericAttributes" :key="attr.Id" :value="attr">{{ attr.Name }}</option>
                                            </select>
                                        </div>

                                        <div v-if="m.Attribute" class="col-md-6">
                                            <h6>Type:</h6>
                                            <select v-model="m.Type" class="form-control">
                                                <option v-for="t in MetricTypes" :key="t" :value="t">{{ t }}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="row mt-3" v-if="m.Attribute">
                                        <div class="col-md-6">
                                            <h6>Currency:</h6>
                                            <select v-model="m.Currency" class="form-control">
                                                <option :value="null">None</option>
                                                <option v-for="c in Currencies" :key="c" :value="c">{{ c }}</option>
                                            </select>
                                        </div>

                                        <div class="col-md-6">
                                            <h6>Decimal places:</h6>
                                            <select v-model="m.Decimals" class="form-control">
                                                <option :value="null">All</option>
                                                <option v-for="d in DecimalsOptions" :key="d" :value="d">{{ d }}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="row mt-3">
                                        <div class="col-md-6">
                                            <h6>Min:</h6>
                                            <input type="number" v-model.number="m.LimitMin" class="form-control">
                                        </div>

                                        <div class="col-md-6">
                                            <h6>Max:</h6>
                                            <input type="number" v-model.number="m.LimitMax" class="form-control">
                                        </div>
                                    </div>
                                    <br />
                                    <h6>Statuses:</h6>
                                    <p v-for="s in m.AlternativesStatusIncludes" :key="s.Id">
                                        <input type="checkbox" v-model="s.Included" /> {{s.Name}}
                                    </p>
                                </div>

                                <div class="card-footer text-right">
                                    <button class="btn btn-success" type="button" @click="m.closeEditor()">Done</button>
                                    <button class="btn btn-danger" type="button" @click="m.deleteMetric()">Delete</button>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div v-for="ch in ChartsView" :key="ch.ChartId" class="mt-3" :class="ch.ChartCssClass">
                            <template v-if="ch.Type === 'balancing'">
                                <div v-show="ch.IsEdited === false" class="card">
                                    <div class="card-header">
                                        <div class="float-right">
                                            <div class="dropdown d-inline mr-2">
                                                <button data-toggle="dropdown" class="btn btn-secondary btn-sm">Legend</button>
                                                <div class="dropdown-menu dropdown-menu-right" role="menu">
                                                    <span v-for="g in AlternativesGroups" :key="g.Name" class="dropdown-item-text">
                                                        <i class="fa fa-square" aria-hidden="true" :style="{color: g.Color}"></i> {{g.Label}}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="dropdown d-inline">
                                                <a data-toggle="dropdown" class="text-dark"><i class="fa fa-lg fa-ellipsis-h"></i></a>
                                                <div class="dropdown-menu dropdown-menu-right" role="menu">
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.IsEdited = true">Edit</a>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.cloneChart()">Clone</a>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.deleteChart()">Delete</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.moveUp()">Move up</a>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.moveDown()">Move down</a>
                                                    <div class="dropdown-divider"></div>
                                                    <h6 class="dropdown-header">Chart size</h6>
                                                    <a class="dropdown-item" @click="ch.setSize('Default')">Default</a>
                                                    <a class="dropdown-item" @click="ch.setSize('Wide')">Wide</a>
                                                    <a class="dropdown-item" @click="ch.setSize('Large')">Large</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" @click="showFullScreen(ch)">Full screen</a>
                                                </div>
                                            </div>
                                        </div>

                                        <h5>{{ch.Title}}</h5>
                                    </div>

                                    <div class="card-body chart-container">
                                        <div :id="`Chart-${ch.ChartId}`" style="max-width: 100%; height: 100%; overflow: hidden;"></div>
                                    </div>
                                </div>

                                <div v-show="ch.IsEdited" class="card">
                                    <div class="card-header">
                                        <div class="float-right">
                                            <a class="pointer p-2" @click="ch.stopEditing()"><i class="fa fa-check fa-lg"></i></a>
                                        </div>
                                        <h5>{{ch.Title}}</h5>
                                    </div>
                                    <div class="card-body">
                                        <div style="height: 40vh; max-height: 40vh; overflow-y: auto; overflow-x: hidden;">
                                            <h6>Title:</h6>
                                            <input type="text" v-model.trim="ch.Title" class="form-control" />
                                            <br />

                                            <h6>Data:</h6>
                                            <select v-model="ch.Attribute" class="form-control">
                                                <option :value="null">Number of projects</option>
                                                <option v-for="attr in NumericAttributes" :key="attr.Id" :value="attr">{{attr.Name}}</option>
                                            </select>
                                            <br />

                                            <div v-if="ch.Attribute">
                                                <select v-model="ch.MetricType" class="form-control">
                                                    <option v-for="t in MetricTypes" :key="t" :value="t">{{t}}</option>
                                                </select>
                                            </div>
                                            <br />

                                            <h6>Statuses:</h6>
                                            <p v-for="s in ch.AlternativesStatusIncludes" :key="s.Id">
                                                <input type="checkbox" v-model="s.Included" /> {{s.Name}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="card-footer text-right">
                                        <button class="btn btn-success" type="button" @click="ch.stopEditing()">Done</button>
                                        <button class="btn btn-danger" type="button" @click="ch.deleteChart()">Delete</button>
                                    </div>
                                </div>
                            </template>

                            <template v-if="ch.Type === 'scatter'">
                                <div v-show="ch.IsEdited === false" class="card">
                                    <div class="card-header">
                                        <div class="float-right">
                                            <div class="dropdown d-inline mr-2">
                                                <button data-toggle="dropdown" class="btn btn-secondary btn-sm">Legend</button>
                                                <div class="dropdown-menu dropdown-menu-right p-3" role="menu" style="min-width: 400px;">
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th>Status</th>
                                                                <th>Color</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td class="align-top">
                                                                    <div v-for="s in ch.ShapesLegend" :key="s.Name">
                                                                        <i :class="s.ShapeIcon"></i> {{s.Name}}
                                                                    </div>
                                                                </td>
                                                                <td class="align-top">
                                                                    <div v-for="g in AlternativesGroups" :key="g.Name">
                                                                        <i class="fa fa-square" aria-hidden="true" :style="{'color': g.Color}"></i> {{g.Label}}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div class="dropdown d-inline">
                                                <a data-toggle="dropdown" class="text-dark">
                                                    <i class="fa fa-lg fa-ellipsis-h"></i>
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-right" role="menu">
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.IsEdited = true">Edit</a>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.cloneChart()">Clone</a>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.deleteChart()">Delete</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.moveUp()">Move up</a>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.moveDown()">Move down</a>
                                                    <div class="dropdown-divider"></div>
                                                    <h6 class="dropdown-header">Chart size</h6>
                                                    <a class="dropdown-item" @click="ch.setSize('Default')">Default</a>
                                                    <a class="dropdown-item" @click="ch.setSize('Wide')">Wide</a>
                                                    <a class="dropdown-item" @click="ch.setSize('Large')">Large</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" @click="showFullScreen(ch)">Full screen</a>
                                                </div>
                                            </div>
                                        </div>


                                        <h5>{{ch.Title}}</h5>
                                    </div>
                                    <div class="card-body chart-container">
                                        <div :id="`Chart-${ch.ChartId}`" style="max-width: 100%; height: 100%; overflow: hidden; "></div>
                                    </div>
                                </div>

                                <div v-show="ch.IsEdited" class="card">
                                    <div class="card-header">
                                        <div class="float-right">
                                            <a class="pointer p-2" @click="ch.stopEditing()">
                                                <i class="fa fa-check fa-lg"></i>
                                            </a>
                                        </div>
                                        <h5>Edit chart</h5>
                                    </div>

                                    <div class="card-body">
                                        <div style="height: 40vh; max-height: 40vh; overflow-y: auto; overflow-x: hidden;">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Chart title:</label>
                                                        <input type="text" v-model.trim="ch.Title" class="form-control" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Cumulative axes, order by:</label>
                                                        <select v-model="ch.RunningTotalOrderAttribute" class="form-control">
                                                            <option :value="null">disabled</option>
                                                            <option v-for="attr in NumericAttributes" :key="attr.Id" :value="attr">{{attr.Name}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Y Axis:</label>
                                                        <select v-model="ch.YAxisAttribute" class="form-control">
                                                            <option v-for="attr in NumericAttributes" :key="attr.Id" :value="attr">{{attr.Name}}</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>X Axis:</label>
                                                        <select v-model="ch.XAxisAttribute" class="form-control">
                                                            <option v-for="attr in NumericAttributes" :key="attr.Id" :value="attr">{{attr.Name}}</option>
                                                        </select>
                                                    </div>
                                                </div>

                                            </div>
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Status</th>
                                                        <th>Shape</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="s in ch.AlternativesStatusIncludes" :key="s.Id">
                                                        <td>{{s.Name}}</td>
                                                        <td>
                                                            <select v-model="s.Shape" class="form-control">
                                                                <option v-for="shape in StatusShapes" :key="shape" :value="shape">{{shape}}</option>
                                                            </select>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="card-footer text-right">
                                        <button class="btn btn-success" type="button" @click="ch.stopEditing()">Done</button>
                                        <button class="btn btn-danger" type="button" @click="ch.deleteChart()">Delete</button>
                                    </div>
                                </div>
                            </template>

                            <template v-if="ch.Type === 'bubble'">
                                <div v-show="ch.IsEdited === false" class="card">
                                    <div class="card-header">
                                        <div class="float-right">
                                            <div class="dropdown d-inline mr-2">
                                                <button data-toggle="dropdown" class="btn btn-secondary btn-sm">Legend</button>
                                                <div class="dropdown-menu dropdown-menu-right" role="menu">
                                                    <span v-for="g in AlternativesGroups" :key="g.Name" class="dropdown-item-text">
                                                        <i class="fa fa-square" aria-hidden="true" :style="{'color': g.Color}"></i> {{g.Label}}
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="dropdown d-inline">
                                                <a data-toggle="dropdown" class="text-dark"><i class="fa fa-lg fa-ellipsis-h"></i></a>
                                                <div class="dropdown-menu dropdown-menu-right" role="menu">
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.IsEdited = true">Edit</a>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.cloneChart()">Clone</a>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.deleteChart()">Delete</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.moveUp()">Move up</a>
                                                    <a v-if="!rm.Readonly" class="dropdown-item" @click="ch.moveDown()">Move down</a>
                                                    <div class="dropdown-divider"></div>
                                                    <h6 class="dropdown-header">Chart size</h6>
                                                    <a class="dropdown-item" @click="ch.setSize('Default')">Default</a>
                                                    <a class="dropdown-item" @click="ch.setSize('Wide')">Wide</a>
                                                    <a class="dropdown-item" @click="ch.setSize('Large')">Large</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" @click="showFullScreen(ch)">Full screen</a>
                                                </div>
                                            </div>
                                        </div>
                                        <h5>{{ch.Title}}</h5>
                                    </div>
                                    <div class="card-body chart-container">
                                        <div :id="`Chart-${ch.ChartId}`" style="max-width: 100%; height: 100%; overflow: hidden; "></div>
                                    </div>
                                </div>

                                <div v-show="ch.IsEdited" class="card">
                                    <div class="card-header">
                                        <div class="float-right">
                                            <a class="pointer p-2" @click="ch.stopEditing()">
                                                <i class="fa fa-check fa-lg"></i>
                                            </a>
                                        </div>
                                        <h5>Edit chart</h5>
                                    </div>

                                    <div class="card-body">
                                        <div class="form-group">
                                            <label>Chart title:</label>
                                            <input type="text" v-model.trim="ch.Title" class="form-control" />
                                        </div>

                                        <h6>Axes:</h6>
                                        <p>
                                            <div class="dropdown">
                                                X Axis:
                                                <a class="text-primary" data-toggle="dropdown">{{ch.XaxisLabel}}</a>
                                                <div class="dropdown-menu" style="overflow-y: auto; max-height: 40vh;">
                                                    <a v-for="attr in NumericAttributes" :key="attr.Id" class="dropdown-item" @click="ch.XAxisAttribute = attr">
                                                        {{attr.Name}}
                                                    </a>
                                                </div>
                                            </div>
                                        </p>

                                        <p>
                                            <div class="dropdown">
                                                Y Axis:
                                                <a class="text-primary" data-toggle="dropdown">{{ch.YaxisLabel}}</a>
                                                <div class="dropdown-menu" style="overflow-y: auto; max-height: 40vh;">
                                                    <a v-for="attr in NumericAttributes" :key="attr.Id" class="dropdown-item" @click="ch.YAxisAttribute = attr">
                                                        {{attr.Name}}
                                                    </a>
                                                </div>
                                            </div>
                                        </p>

                                        <p>
                                            <div class="dropdown">
                                                Bubble Size:
                                                <a class="text-primary" data-toggle="dropdown">{{ch.ZAxisOption.Label}}</a>
                                                <div class="dropdown-menu" style="overflow-y: auto; max-height: 40vh;">
                                                    <a class="dropdown-item" @click="ch.ZAxisSetEqualCommand()">Equal</a>
                                                    <a class="dropdown-item" @click="ch.ZAxisSetXYRatioCommand()">Ratio: X/Y</a>
                                                    <a class="dropdown-item" @click="ch.ZAxisSetYXRatioCommand()">Ratio: Y/X</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a v-for="attr in NumericAttributes" :key="attr.Id" class="dropdown-item" @click="ch.ZAxisSetAttributeCommand(attr)">
                                                        {{attr.Name}}
                                                    </a>
                                                </div>
                                            </div>
                                        </p>

                                        <br />

                                        <h6>Statuses:</h6>
                                        <p v-for="s in ch.AlternativesStatusIncludes" :key="s.Id">
                                            <input type="checkbox" v-model="s.Included" /> {{s.Name}}
                                        </p>
                                    </div>

                                    <div class="card-footer text-right">
                                        <button class="btn btn-success" type="button" @click="ch.stopEditing()">Done</button>
                                        <button class="btn btn-danger" type="button" @click="ch.deleteChart()">Delete</button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <br />

                    <div class="bg-light border rounded p-2 mb-1">
                        <div class="d-flex justify-content-between">

                            <div class="btn-toolbar">
                                <template v-if="SelectedAlternatives.length > 0">
                                    <div class="btn-group mr-2">
                                        <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                                            Edit selected ({{SelectedAlternatives.length}})
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-scrollable">
                                            <a class="dropdown-item" @click="showBulkStatusEditor">Status</a>
                                            <div class="dropdown-divider"></div>
                                            <div v-for="s in BulkEditableAttributesBySection" :key="s.Section">
                                                <h6 v-if="s.Section" class="dropdown-header">{{s.Section}}</h6>
                                                <a v-for="attr in s.Items" :key="attr.Id" class="dropdown-item" @click="showBulkAttributeValueEditor(attr)">
                                                    {{attr.Name}}
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="btn-group mr-2">
                                        <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown">
                                            Add to list ({{SelectedAlternatives.length}})
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" @click="showStaticViewBuilder">
                                                Create new list
                                            </a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" v-for="l in StaticLists" :key="l.Id" @click="handleAddAlternativesToStaticViewCommand(l.Id)">
                                                {{l.Name}}
                                            </a>
                                        </div>
                                    </div>

                                    <div class="btn-group mr-2">
                                        <button class="btn btn-secondary" type="button" :disabled="!IsStaticList" @click="handleRemoveAlternativesFromStaticViewCommand">
                                            Exclude from list ({{SelectedAlternatives.length}})
                                        </button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary" type="button" @click="showAlternativesComparison">
                                            Compare ({{SelectedAlternatives.length}})
                                        </button>
                                    </div>
                                </template>
                            </div>


                            <div class="p-2">
                                <a v-if="!rm.Readonly" class="pointer pr-2" @click="showGridColumnsEditor" title="Edit columns">
                                    <i class="fa fa-columns fa-lg"></i>
                                </a>
                                <a class="pointer pr-2" @click="exportGrid" title="Download to spreadsheet">
                                    <i class="fa fa-download fa-lg"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div id="pbGrid"></div>

                </div>
            </div>
            <br />
            <br />
        </div>
    </div>
</template>

<style scoped>
    .chart-large .chart-container {
        height: 80vh;
    }

    .chart-wide .chart-container {
        height: 40vh;
    }

    .chart-default .chart-container {
        height: 40vh;
    }
</style>
